import { produce } from 'immer'
import type { State, ActivitySummaryTableState } from '../../typings'

export const setActivitySummaryTableStateProducer = produce<
  State,
  [Partial<ActivitySummaryTableState>]
>((draft, payload) => {
  draft.tableState = {
    ...draft.tableState,
    ...payload,
  }
})
